import { render, staticRenderFns } from "./GeneralDataTable.vue?vue&type=template&id=27c5ae1e"
import script from "./GeneralDataTable.vue?vue&type=script&lang=js"
export * from "./GeneralDataTable.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataTable.vue?vue&type=style&index=0&id=27c5ae1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports